import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

export const useOrganizationId = () => {
    return useSelector((state: Store) => state.organization.info.organization.id);
};
